import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import sliderone from "../Images/slider image 1.webp";
import slidertwo from "../Images/cover1.png";
import sliderthree from "../Images/cover2.jpg";
import sliderfour from "../Images/cover3.jpeg";


const Sliderimg = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    className: "slides",
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 4000,
  };
  return (
    <>
      <div className="slider-container">
        <Slider {...settings}>
          <div className="">
            <img src={sliderone} className="w-full h-[250px] md:h-[700px]   " />
          </div>
          <div className="">
            <img src={slidertwo} className="w-full h-[250px] md:h-[700px] " />
          </div>
          <div className="">
            <img src={sliderthree} className="w-full h-[250px] md:h-[700px]" />
          </div>
          <div className="">
            <img src={sliderfour} className="w-full h-[250px] md:h-[700px]" />
          </div>

        </Slider>
      </div>
    </>
  );
};

export default Sliderimg;
